import {
  useApi,
  UserFilteringDtoOptions,
  Users200Response,
  UserSortingDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { UserQueryMode } from '@issuemanager/constants';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export type UseUsersParams = {
  sort?: UserSortingDtoOptions;
  filter?: UserFilteringDtoOptions;
  page?: number;
  limit?: number;
  enabled?: boolean;
  handleError?: boolean;
};

export function useUsers(params: UseUsersParams = {}) {
  const {
    page = 0,
    limit = 10,
    sort,
    filter,
    enabled = true,
    handleError = false,
  } = params;

  const queryClient = useQueryClient();
  const api = useApi();

  const filters = {
    ...filter,
    queryMode: filter?.queryMode ?? UserQueryMode.ALL_USERS,
  };

  return {
    ...useQuery<Users200Response, ExtendedAxiosError>({
      queryKey: ['users', page, limit, sort, filters, enabled],
      queryFn: () =>
        api.usersApi.users(page, limit, sort, filters).then((r) => r.data),
      enabled,
      meta: {
        handleError,
      },
    }),
    invalidate: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', page, limit, sort, filters, enabled],
      });
    },
  };
}
